"use client";

import Link from "next/link";
import { Typography, Collapse, Card, Button } from "antd";
import { SiteHeader, SiteFooter } from "@/widgets/site-layout";
import { faqItems } from "@/shared/config/faqItems";
import { PRODUCT_NAME } from "@/shared/config/labels";

const { Title, Paragraph, Text } = Typography;

export default function FaqPage() {
  return (
    <>
      <SiteHeader />
      <main style={{ padding: "64px 24px", background: "#f5f5f5", flex: 1 }}>
        <div style={{ maxWidth: 720, margin: "0 auto" }}>
          <Title level={1} style={{ textAlign: "center" }}>
            Частые вопросы
          </Title>
          <Paragraph type="secondary" style={{ textAlign: "center", marginTop: 16 }}>
            Ответы на популярные вопросы о платформе «{PRODUCT_NAME}»
          </Paragraph>

          <Card style={{ marginTop: 32 }}>
            <Collapse
              items={faqItems.map((item) => ({
                key: item.q,
                label: item.q,
                children: <Text type="secondary">{item.a}</Text>,
              }))}
            />
          </Card>

          <div style={{ marginTop: 32, textAlign: "center" }}>
            <Paragraph type="secondary">Не нашли ответ?</Paragraph>
            <Link href="/contact">
              <Button type="primary">Написать нам</Button>
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </>
  );
}
